/* src/app/components/submission-device-registration/submission-device-registration.component.scss */
/*# sourceMappingURL=submission-device-registration.component.css.map */
